import { SkeletonItem } from '../page-template'

import styles from './default-render-loading-cell.module.scss';


const minWidthPercent = 50 as const
const maxWidthPercent = 100 as const
const itemHeight = 17.25 as const

export const defaultRenderLoadingCell = () => {
  const width = `${Math.floor(Math.random() * (maxWidthPercent - minWidthPercent + 1)) + minWidthPercent}%`
  return (
    <SkeletonItem
      className={styles.root}
      style={{ width, height: `${itemHeight}px` }}
    />
  )
}
